// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPrescriberRequest {
    static getAttributeTypeMap() {
        return MedicalEligibilityPrescriberRequest.attributeTypeMap;
    }
}
MedicalEligibilityPrescriberRequest.discriminator = undefined;
MedicalEligibilityPrescriberRequest.additionalProperties = false;
MedicalEligibilityPrescriberRequest.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalEligibilityAddress"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPrescriberRequest.js.map